import { render, staticRenderFns } from "./OP_BasicSummary.vue?vue&type=template&id=b6f751d0&scoped=true&"
import script from "./OP_BasicSummary.vue?vue&type=script&lang=js&"
export * from "./OP_BasicSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f751d0",
  null
  
)

export default component.exports